import { GET_CAJAS_CENTRO, MODIFY_CAJA_CENTRO, ADD_CAJA_CENTRO, REMOVE_CAJA_CENTRO } from '../constants/action_types';

const initialState = { cajasCentro: [], isLoading: false };

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_CAJAS_CENTRO:

            return {
                cajasCentro: [],
                isLoading: true
            };
        case GET_CAJAS_CENTRO + "_SUCCESS":

            return {
                cajasCentro: action.payload.data,
                isLoading: false
            };

        case MODIFY_CAJA_CENTRO:

            return {
                cajasCentro: state.cajasCentro.map((caja) => {
                    if (caja.id !== action.payload.id) return caja;
                    else return action.payload;
                }),
                isLoading: false
            };

        case ADD_CAJA_CENTRO:

            const newArr = [...state.cajasCentro, action.payload]

            return {
                cajasCentro: newArr,
                isLoading: false
            };

        case REMOVE_CAJA_CENTRO:

            return {
                cajasCentro: state.cajasCentro.filter(caja => caja.id !== action.payload.id),
                isLoading: false
            };


        default:

            return state;
    }
}